import React, { useState } from "react";
import Stepper from "./Stepper";
import ContactForm from "./ContactForm";
import SpecimenForm from "./SpecimenForm";
import LogisticsForm from "./LogisticsForm";
import CommentsForm from "./CommentsForm";

const RFQFormContainer = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [allData, setAllData] = useState({});

  const nextStep = (stepData) => {
    setAllData((prev) => ({ ...prev, ...stepData }));
    setCurrentStep((prev) => prev + 1);
  };

  const prevStep = () => setCurrentStep((prev) => prev - 1);

  const handleFinalSubmit = (finalStepData) => {
    const finalRFQ = { ...allData, ...finalStepData };
    console.log("Submitting Final Data:", finalRFQ);
    setIsSubmitted(true);
  };

  if (isSubmitted) {
    return (
      <div className="max-w-[800px] mx-auto text-center py-20 px-4">
        <div className="bg-white p-12 rounded-[2rem] shadow-xl border border-[#183076]">
          <h2 className="text-[30px] md:text-[40px] font-extrabold text-[#183076] mb-4">
            RFQ Submitted!
          </h2>
          <p className="text-[18px] text-slate-500 mb-10">
            Our team will get back to you within 24-48 hours.
          </p>
          <button
            onClick={() => (window.location.href = "/")}
            className="px-12 py-4 bg-[#183076] text-white rounded-full font-bold shadow-lg"
          >
            Back to Home
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full">
      <Stepper currentStep={currentStep} />
      <div className="mt-16">
        {currentStep === 1 && (
          <ContactForm onNext={nextStep} defaultValues={allData} />
        )}
        {currentStep === 2 && (
          <SpecimenForm
            onNext={nextStep}
            onBack={prevStep}
            defaultValues={allData}
          />
        )}
        {currentStep === 3 && (
          <LogisticsForm
            onNext={nextStep}
            onBack={prevStep}
            defaultValues={allData}
          />
        )}
        {currentStep === 4 && (
          <CommentsForm
            onSubmit={handleFinalSubmit}
            onBack={prevStep}
            defaultValues={allData}
          />
        )}
      </div>
    </div>
  );
};
export default RFQFormContainer;
